import { FC, useMemo } from 'react';
import { SampleScope, seed } from '../../../../components/FrostedGate/SampleScope';
import { customFieldsListAtom } from '../../../../services/state/AdminPanel/CustomFieldsStateJ';
import { kpiConfigAtom, kpiGroupsAtom } from '../../../../services/state/KPIConfigState';
import {
  NEW_KPI_TEMPLATE_FORM,
  PREVIEW_KPI_FIELDS,
  PREVIEW_KPI_TEMPLATE_FORM,
} from '../../kpi-module.fixtures';
import { CustomKpiTemplateForm } from './CustomKpiTemplateForm';

// The KPI form dialog behind the editor also reads the groups and custom fields.
const SEEDS = [
  seed(kpiConfigAtom, PREVIEW_KPI_FIELDS),
  seed(kpiGroupsAtom, []),
  seed(customFieldsListAtom, []),
];

interface KpiTemplatePreviewProps {
  /** The template the sub-nav has selected; the sample template's name otherwise. */
  name?: string;
  /** The Add New route opens the editor on an empty, unsaved template, as the live page does. */
  isNew?: boolean;
}

/** The live custom template editor over a sample template, while the module is frosted. */
export const KpiTemplatePreview: FC<KpiTemplatePreviewProps> = ({ name, isNew = false }) => {
  const initialValues = useMemo(
    () =>
      isNew
        ? NEW_KPI_TEMPLATE_FORM
        : { ...PREVIEW_KPI_TEMPLATE_FORM, name: name ?? PREVIEW_KPI_TEMPLATE_FORM.name },
    [name, isNew]
  );

  return (
    <SampleScope seeds={SEEDS}>
      <CustomKpiTemplateForm key={initialValues.name} initialValues={initialValues} />
    </SampleScope>
  );
};
